export default __webpack_public_path__ + "static/media/vendor_icon.c8c02b81.svg";